(() => {
  const PRICE_SELECTOR = [
    '.money',
    '.price',
    '.price-item',
    '.product-option',
    '.cart-item__old-price',
    '.cart-item__final-price',
    '.totals__total-value',
    '.tl-current-price',
    '.tl-submit-price',
    '.tl-cart-total-prices',
    '.quantity-break-price',
    '.quantity-break-original-price',
    '.upsell-price',
    '[class*="price"]'
  ].join(',');

  const IGNORE_SELECTOR = [
    'script',
    'style',
    'noscript',
    'template',
    'svg',
    'input',
    'textarea',
    'select',
    'option',
    '[data-price-no-cents-ignore]'
  ].join(',');

  const currencyPattern = /[$€£¥]|\b(?:USD|CAD|AUD|NZD|EUR|GBP)\b/;
  const centPattern = /[.,]\d{2}(?!\d)/;
  const symbolAmountPattern = /([$€£¥])\s*((?:\d[\d,.\s]*\d|\d+))[.,]\d{2}(?!\d)(\s?(?:USD|CAD|AUD|NZD|EUR|GBP))?/g;
  const codeBeforePattern = /\b(USD|CAD|AUD|NZD|EUR|GBP)\s+((?:\d[\d,.\s]*\d|\d+))[.,]\d{2}(?!\d)/g;
  const codeAfterPattern = /((?:\d[\d,.\s]*\d|\d+))[.,]\d{2}(?!\d)(\s?(?:USD|CAD|AUD|NZD|EUR|GBP)\b)/g;
  const barePricePattern = /((?:\d[\d,.\s]*\d|\d+))[.,]\d{2}(?!\d)/g;

  function stripCents(value, allowBareAmount = false) {
    if (typeof value !== 'string' || !centPattern.test(value)) return value;

    const hasCurrency = currencyPattern.test(value);
    if (!hasCurrency && !allowBareAmount) return value;

    let formatted = value
      .replace(symbolAmountPattern, '$1$2$3')
      .replace(codeBeforePattern, '$1 $2')
      .replace(codeAfterPattern, '$1$2');

    if (allowBareAmount) {
      formatted = formatted.replace(barePricePattern, '$1');
    }

    return formatted;
  }

  function canFormatTextNode(node) {
    const parent = node.parentElement;
    if (!parent || parent.closest(IGNORE_SELECTOR)) return false;

    const text = node.nodeValue;
    if (!text || !centPattern.test(text)) return false;

    return currencyPattern.test(text) || Boolean(parent.closest(PRICE_SELECTOR));
  }

  function formatTextNode(node) {
    if (!canFormatTextNode(node)) return;

    const allowBareAmount = Boolean(node.parentElement.closest(PRICE_SELECTOR));
    const formatted = stripCents(node.nodeValue, allowBareAmount);
    if (formatted !== node.nodeValue) {
      node.nodeValue = formatted;
    }
  }

  function formatTree(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      formatTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.closest(IGNORE_SELECTOR)) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      formatTextNode(textNode);
      textNode = walker.nextNode();
    }
  }

  function refresh() {
    formatTree(document.body);
  }

  const originalFormatMoney = window.Shopify && window.Shopify.formatMoney;
  if (typeof originalFormatMoney === 'function') {
    window.Shopify.formatMoney = function formatMoneyWithoutCents(...args) {
      return stripCents(originalFormatMoney.apply(this, args), true);
    };
  }

  window.RezunePriceNoCents = {
    format: (value) => stripCents(value, true),
    refresh
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  let pending = false;
  const changedNodes = new Set();

  function scheduleFormat() {
    if (pending) return;
    pending = true;

    window.requestAnimationFrame(() => {
      changedNodes.forEach((node) => formatTree(node));
      changedNodes.clear();
      pending = false;
    });
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        changedNodes.add(mutation.target);
      }

      mutation.addedNodes.forEach((node) => {
        changedNodes.add(node);
      });
    });

    scheduleFormat();
  });

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
